import React from "react";
import { QRCodeSVG } from "@rc-component/qrcode";
import { LockKeyhole, Smartphone } from "lucide-react";
import { useTranslation } from "react-i18next";

export function DesktopMobileHandoff({ mobileUrl }) {
  const { t } = useTranslation();

  return (
    <section className="desktop-mobile-handoff mx-auto my-auto flex h-full w-full items-center justify-center overflow-auto px-5 py-4 sm:px-8">
      <div className="kyc-surface w-full max-w-xl rounded-3xl border border-white/10 bg-white px-6 py-8 text-center sm:px-10 sm:py-10">
        <span className="mx-auto flex size-14 items-center justify-center rounded-2xl bg-teal-50 text-teal-800 ring-1 ring-teal-100">
          <Smartphone className="size-6" strokeWidth={2} aria-hidden="true" />
        </span>
        <h1 className="mt-5 text-2xl font-semibold leading-tight tracking-[-0.035em] text-slate-950 sm:text-[1.75rem]">
          {t("kyc.desktopHandoff.title")}
        </h1>
        <p className="mx-auto mt-2 max-w-md text-sm leading-6 text-slate-600">
          {t("kyc.desktopHandoff.description")}
        </p>

        <div
          className="mx-auto mt-6 flex size-52 items-center justify-center rounded-2xl border border-slate-200 bg-white p-2 shadow-[0_12px_35px_rgba(15,23,42,0.10)]"
          role="img"
          aria-label={t("kyc.desktopHandoff.qrLabel")}
        >
          <QRCodeSVG
            value={mobileUrl}
            size={188}
            fgColor="#0f172a"
            bgColor="#ffffff"
            level="M"
            marginSize={2}
            title={t("kyc.desktopHandoff.qrLabel")}
          />
        </div>

        <p className="mt-5 flex items-center justify-center gap-1.5 text-xs text-slate-500">
          <LockKeyhole className="size-3.5 text-teal-700" aria-hidden="true" />
          {t("kyc.desktopHandoff.securityNote")}
        </p>
      </div>
    </section>
  );
}
